module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-title-sp@2x_63c6be9f4f866cca0d357f6e63440739.png";